import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Subject } from "rxjs/Subject";
import * as _ from 'lodash';
import { Subscription } from 'rxjs/Subscription';

/**Local file */

import { spekwoType, spekWalk, spekwo } from '../../../utils/index';

import { SolutionFormService } from '../../solutionForm/solutionForm.service';

import { InsReportSrcQueryService } from '../../../queryFiles/index';

@Component({
    selector: 'email-popup',
    templateUrl: './emailPopup.component.html',
    styleUrls: ['./emailPopup.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class EmailPopupComponent {

    spekwoType = spekwoType;
    spekWalk = spekWalk;
    spekwoValues = spekwo;

    currentOrderId: number;
    alterEmail: string;
    nodeId: string;

    insReportIdChangeSubscription: Subscription;
    saveEmailSubscription: Subscription;

    addEmailSubscription = new Subject<void>();

    constructor(
        public dialogRef: MatDialogRef<EmailPopupComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,

        /**Service file */
        public solutionFormService: SolutionFormService,

        /*Query file*/
        public insReportSrcQueryService: InsReportSrcQueryService

    ) {
        this.currentOrderId = data.currentOrderId
    }

    ngOnInit() {
        this.insReportIdChangeSubscription =
            this.solutionFormService.insReportIdChange.subscribe(data => {
                this.nodeId = data && data.nodeId;
            })
    }

    ngOnDestroy() {
        this.insReportIdChangeSubscription.unsubscribe();
        this.saveEmailSubscription && this.saveEmailSubscription.unsubscribe();
    }

    saveEmail() {

        this.saveEmailSubscription = this.insReportSrcQueryService
            .ALTER_EMAIL_ID_MUTATION(this.currentOrderId, this.alterEmail, this.nodeId)
            .takeUntil(this.addEmailSubscription)
            .subscribe(() => {

                this.addEmailSubscription.complete(); /**Complete subscription */
            }, () => {
                this.dialogRef.close(['failed', '']);

            }, () => {
                this.dialogRef.close(['save', this.alterEmail]); /**Complete subscription */ //pass alter email

            })

    }

    cancel(){
        this.dialogRef.close(['cancel', '']);
    }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/solutionForm/email-popup/emailPopup.component.ts